enum HubSpotContactPropertyEnum {
    FITNESS_FOCUS = 'fitness_focus',
}

export default HubSpotContactPropertyEnum;
